import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-icon_full",
  "use": "icon-icon_full-usage",
  "viewBox": "0 0 44 44",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 44 44\" id=\"icon-icon_full\"><g fill=\"none\" fill-rule=\"evenodd\" stroke=\"#FFF\" stroke-width=\"3\"><rect x=\"3.5\" y=\"3.5\" width=\"37\" height=\"37\" rx=\"4\" /><path d=\"M21 32h-5a4 4 0 0 1-4-4v-4M23 12h5a4 4 0 0 1 4 4v4\" stroke-linecap=\"round\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol